export function convertInchesToCm(v) {
    return Math.round(v / 2.54);
};

export function convertInchesToFeet(inches) {
    const feet = Math.floor(inches / 12);
    inches %= 12;
    return {
        feet,
        inches
    };
};

export function convertCmToInches(v) {
    return Math.round((v / INCHES_IN_METER) * 100);
};



// WEBPACK FOOTER //
// ./src/client/lib/conversions.js